import React from 'react';
import { DataCard } from 'anf-core-react';
import { billingInfoCardProps } from './props';
import BillingInfoItem from './BillingInfoItem';
import { ShippingAddress } from '../Common';

export default function BillingInfoCard({ billingInfo }) {
  const { title, billingInfoList } = billingInfo;

  return (
    <div className="billing-info-card" data-testid="billing-info-card">
      {billingInfoList.map((billingInfoItem, index) => {
        const i = index;
        return (
          <React.Fragment key={`billingInfoItem${i}`}>
            <BillingInfoItem title={title?.value} billingInfoItem={billingInfoItem} />
            {billingInfoItem.billingAddress && (
              <DataCard variant="boxed">
                <ShippingAddress className="billing-address" shippingAddress={billingInfoItem.billingAddress} />
              </DataCard>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

BillingInfoCard.propTypes = billingInfoCardProps;
